import { connect } from 'react-redux';
import { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { breakpoints } from 'styles';
import { ReaderBlockEmbed } from 'components/reader/blocks/embed';

const ScormSummary = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  class extends Component {
    getStatusSummary(label, summary) {
      const { theme, messages } = this.props;

      return (
        <div className="status">
          <div className="status-content">
            <div className="status-text">{label}</div>
            <div className="status-info">
              <div className="status-percentage">
                {isNaN(summary) ? (
                  <div className="status-percentage-content">
                    {messages.commonUnknown}
                  </div>
                ) : (
                  <div className="status-percentage-content">
                    {`${Math.round(summary)}%`}
                    <div className="status-percentage-indicator">
                      <div
                        className="status-percentage-indicator-fill"
                        style={{ width: `${Math.round(summary)}%` }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <style jsx>{`
            .status {
              background-color: white;
              border-radius: 5px;
              color: ${theme.textColorLight};
              font-size: 1.4rem;
              padding: 8px 10px;
            }
            .status:not(:first-child) {
              margin-top: 10px;
            }
            .status-text {
              display: flex;
              flex-grow: 1;
              flex-shrink: 1;
            }
            .status-text-inner {
              word-break: break-word;
            }
            .status-text-inner :global(p) {
              margin: 8px 0 0;
            }
            .status-text-inner :global(p:first-child) {
              margin-top: 0;
            }
            .status-info {
              display: flex;
            }
            .status-correct {
              flex-grow: 1;
              flex-shrink: 0;
              font-size: 1.2rem;
              margin-left: 10px;
              min-width: 0;
              text-align: right;
            }
            .status-percentage {
              margin-left: 10px;
            }
            .status-percentage-content {
              align-items: center;
              background-color: ${theme.lightGrey};
              border-radius: 4px;
              display: flex;
              font-size: 1.2rem;
              font-weight: 600;
              padding: 1px 5px;
              white-space: nowrap;
              width: 85px;
              justify-content: center;
            }
            .status-percentage-indicator {
              background-color: ${theme.lightGreyDark};
              border-radius: 3px;
              display: inline-block;
              height: 6px;
              margin-left: 5px;
              overflow: hidden;
              width: 50px;
            }
            @keyframes statusPercentageFill {
              0% {
                width: 0;
              }
            }
            .status-percentage-indicator-fill {
              animation: statusPercentageFill 1s;
              background-color: ${theme.successColor};
              height: 100%;
            }
            @media (max-width: ${breakpoints.small - 1}px) {
              .status-info {
                margin-top: 10px;
              }
            }
            @media (min-width: ${breakpoints.small}px) {
              .status-content {
                display: flex;
              }
            }
          `}</style>
        </div>
      );
    }

    render() {
      const { courseSlug, messages, task, theme } = this.props;

      const answerStatusList = task.answers.map((answer) => {
        return {
          completion: answer.data && answer.data.completion,
          success: answer.data && answer.data.success,
          score: answer.data && answer.data.score
        };
      });
      if (answerStatusList.length) {
        let completionCount = 0;
        let successSum = 0;
        let successCount = 0;
        let scoreSum = 0;
        let scoreCount = 0;
        for (let i = 0; i < answerStatusList.length; i++) {
          if (!isNaN(answerStatusList[i].completion)) {
            completionCount += answerStatusList[i].completion;
          }
          if (!isNaN(answerStatusList[i].success)) {
            successSum += answerStatusList[i].success;
            successCount++;
          }
          if (!isNaN(answerStatusList[i].success)) {
            scoreSum += answerStatusList[i].score;
            scoreCount++;
          }
        }
        const averageCompletion =
          (100 * completionCount) / answerStatusList.length;
        const averageSuccess = (100 * successSum) / successCount;
        const averageScore = (100 * scoreSum) / scoreCount;

        const title = task?.data?.file?.title
          ?.replace(/.zip$/, '')
          .replace('_', ' ');
        const blockThumbnailUrl = task?.data?.file?.baseUrl?.replace(
          /uploads\/decompressed.*$/,
          `blocks/${task.id}.png`
        );

        return (
          <div className="summary">
            <div className="block-preview">
              <img
                alt={title}
                title={title}
                onError={this.handleImageError}
                src={blockThumbnailUrl}
              />
            </div>
            <div className="status-container">
              {this.getStatusSummary(
                messages.tasksScormStatusCompletion,
                averageCompletion
              )}
              {successCount > 0 &&
                this.getStatusSummary(
                  messages.tasksScormStatusSuccess,
                  averageSuccess
                )}
              {scoreCount > 0 &&
                this.getStatusSummary(
                  messages.tasksScormStatusScore,
                  averageScore
                )}
            </div>

            <style jsx>{`
              .block-preview {
                height: 124px;
                width: 160px;
                overflow: hidden;
                position: relative;
                border: 1px solid ${theme.lightGreyDark};
                border-radius: 5px;
                background: white;
                display: inline-block;
                margin-right: 10px;
              }
              .block-preview img {
                max-width: 160px;
              }
              .status-container {
                display: inline-block;
                width: calc(100% - 170px);
                vertical-align: top;
              }
            `}</style>
          </div>
        );
      }
      return null;
    }
  }
);

export default ScormSummary;
